import { render, staticRenderFns } from "./date-range-format-editor.vue?vue&type=template&id=505ea992&scoped=true&"
import script from "./date-range-format-editor.vue?vue&type=script&lang=js&"
export * from "./date-range-format-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505ea992",
  null
  
)

export default component.exports